import { render, staticRenderFns } from "./CustomerPoolTask.vue?vue&type=template&id=5588698c&scoped=true"
import script from "./CustomerPoolTask.vue?vue&type=script&lang=js"
export * from "./CustomerPoolTask.vue?vue&type=script&lang=js"
import style0 from "./CustomerPoolTask.vue?vue&type=style&index=0&id=5588698c&prod&scoped=true&lang=css"
import style1 from "./CustomerPoolTask.vue?vue&type=style&index=1&id=5588698c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588698c",
  null
  
)

export default component.exports